<template>
  <div>
    <opinionFeedback />
  </div>
</template>
<script>
import opinionFeedback from '../../../home/siteConfiguration/opinionFeedback'
export default {
  components: {
    opinionFeedback,
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped></style>